import React, { useState, useEffect, cloneElement } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import useDisableBackButton from 'Hooks/useDisableBackButton'

import {
  _AppModalPageOverlay,
  _AppModalPageContent,

} from './styles.js'

const AppModalPage = ({
  closeModalPage, isModalPageOpen, children, modalKey,
}) => {
  const [modalLevel, setModalLevel] = useState(null)
  useEffect(() => {
    const newModalLevel = document.querySelectorAll('.appPageModal').length
    setModalLevel(newModalLevel || 1)
  }, [])


  const isOtherModalOpen = !!document.querySelectorAll('.mainSiteModal').length ||
    !!document.querySelectorAll('.photosAndLocationModal').length ||
    !!document.querySelectorAll('._GalleryModal').length ||
    !!document.querySelectorAll('.schoolModal').length

  useDisableBackButton({
    enabled: modalLevel === document.querySelectorAll('.appPageModal').length && !isOtherModalOpen,
    onBackButtonPress: () => setTimeout(closeModalPage, 5),
  })

  return (
    <Modal
      isOpen={isModalPageOpen}
      onRequestClose={closeModalPage}
      className="_AppModalPage"
      overlayClassName={'_AppModalPageOverlay' + modalKey}
      portalClassName={`appPageModal ${modalKey} page-modal-level-${modalLevel}`}
      // eslint-disable-next-line react/no-unstable-nested-components
      overlayElement={(props, contentElement) => (
        <_AppModalPageOverlay {...props} >{contentElement}</_AppModalPageOverlay>
      )}
      // eslint-disable-next-line react/no-unstable-nested-components
      contentElement={(props, child) => (
        <_AppModalPageContent {...props} id={`appModalPage-level-${modalLevel}`} >{child}</_AppModalPageContent>
      )}
      key={modalKey}
    >
      {cloneElement(children, { pageModalLevel: `level-${modalLevel}` })}
    </Modal>
  )
}


AppModalPage.propTypes = {
  isModalPageOpen: PropTypes.bool,
  closeModalPage: PropTypes.func,
  children: PropTypes.node,
  modalKey: PropTypes.string,
}

export default AppModalPage
